// 命令字典
export default {
  ArtPenStyle: 1, // 画笔样式
  ArtDrawLine: 2, // 画线命令
  ArtClearLine: 3, // 清除所有画线命令
  ArtPicScale: 4, // 图片缩放
  ArtPicMove: 5, // 图片移动
  ArtPicImage: 6, // 图片消息
  ArtPicChange: 7, // 图片切换
  ArtPicSelecte: 8, // 选择历史图片
  ArtVideoPerspective: 9, // 调整对方透视
  ArtVideoRecord: 10, // 开启/关闭对方的视频录制
  ArtVideoConnect: 11, // 摄像头连接/断开
  ArtLogUpload: 12, // 通知对端进行日志上报
  ArtClassStart: 13, // 开始上课/下课
  ArtNotifyMessage: 15, // 通知信息
  ArtCommandControl: 16, // 控制指令
  ArtVideoWindowInfo: 17, // 发送视频设置指令
  ArtWindowStateInfo: 18, // 同步视频及部分指令
  ArtVideoFocus: 19, // 视频聚焦操作
  ArtSayHello: 1001, // 新成员进入房间命令
  ArtRepHello: 2001, // 回复新成员进入房间命令
  ArtSyncScreen: 1003, // 霸屏命令
  ArtRepLine: 2004, // 回复画线数据
  ArtRepUpload: 2005, // 回复请求上传图片的命令
  ArtRepAllImage: 2009, // 回复请求所有状态的命令
  ArtVideoInfo: 1011, // 发送视频
  ArtVideoReady: 2011, // 视频是否准备好可以播放
  ArtConVideo: 1012, // 视频控制
  ArtSyncVideo: 1013, // 视频同步
  ArtCheckPerformance: 1667, // 检测对方性能
  ArtRepPerformance: 2667, // 回复性能检测
  ArtSyncAllstate: 1009, // 发送请求同步命令
  ArtFileHeader: 100, // 文件头信息
  ArtRecordeImage: 106, // 录制图片信息
  ArtConVideoLine: 1014, // 切换线路
  ArtCourseChoose: 1015, // 互动答题选择交互同步
  // code message (无消息体)
  ArtUpload: 1005,
  ArtSyncDownload: 1007,
  ArtSyncDownloaded: 1008,
  ArtCheckNetwork: 1666, // 缺少类型
  ArtRepNetwork: 2666,
  ArtSayBye: 1002,
  ArtCourseReplace: 10004,
  ArtKickOutTeacher: 10006, // 鉴黄踢出
  ArtKickOutWarning: 10007, // 鉴黄提醒
  ArtMeiYuSignIn: 10021, // 美育伪直播签到
  ArtMeiYuAnswerInfo: 10020, // 美育伪直播答题
  ArtMeiYuConcurrentUsers: 10019, // 美育伪直播在线人数
  ArtMeiYuMagicStone: 10018, // 美育伪直播魔法石
  ArtMeiYuFlower: 10017, // 美育伪直播送花
  ArtExtensionVideo: 10032, // just信令
  ArtEnterBackgroundControl: 10041, // 学生后台运行
  // ArtRepJoin: 2000,
  // ArtSyncLine: 2008,
  ArtClassRestStart: 1016, // 开始课间休息
  ArtClassRestEnd: 1017, // 结束课间休息
  ArtVoiceViolationTeaControl: 100000, // 老师语音违规
  ArtVoiceViolationStuControl: 100001, // 学生语音违规
  ArtVideoControl: 10031, // 小班课窗口视频开关
  ArtAiBoxShow: 10060, // ai百宝箱
  ArtAiBoxMsg: 10061, // ai百宝箱
  ArtAiBoxOffset: 10062, // ai百宝箱 滚动
  ArtShowH5CoursewareControl: 10042, // 妙笔AI显示控制
  ArtWebViewControl: 10043, // 课中浏览器相关
  ArtSwitchWhiteBoardTab: 10044, // 切换白板Tab
  ArtScreenShareControl: 10045 // 共享屏幕
}
